import { render, staticRenderFns } from "./HandoutTabSettings.vue?vue&type=template&id=4e3b7162&"
import script from "./HandoutTabSettings.vue?vue&type=script&lang=js&"
export * from "./HandoutTabSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDivider,VSwitch})
